(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_collection_home"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".mySwiper_home_collections ", {
      slidesPerView: 4,
      spaceBetween: 20,
  pagination: {
        el: ".swiper-pagination",
        type: "fraction",
  },
  scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
  },  
  navigation: {
  nextEl: ".swiper-button-next_col",
  prevEl: ".swiper-button-prev_col",
  },
      breakpoints: {
        350: {
          slidesPerView: 1.25,
          spaceBetween: 20
        },
         400: {
          slidesPerView: 1.25,
          spaceBetween: 20
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_spbkup"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_product_sec"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".mySwiper_home_products ", {
      slidesPerView: 2.3,
      spaceBetween: 14,
      breakpoints: {
        480: {
          slidesPerView: 2.6,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main_quiz"] && !window.DesignMode) return;
  try {
    
$(".quiz_input_items input").change(function () {
  $("li.grid__item.quiz_li_items").attr('data_length', 0);
  $(".quiz_input_items input:checked").each(function (index) {
    let thisval = $(this).val();
    $("li.grid__item.quiz_li_items").each(function () {
      let $this = $(this);
      var value = $this.attr("data_tag");
      var match = $this.attr("data_length");
      let number = parseInt(match);
      let lengthInput = $(".quiz_input_items input:checked").length;
      if (value.includes(thisval)) {
        $this.attr("data_length", number + 1);
      }
    let check = $this.attr("data_length")
    let numberttt = parseInt(check);
      if (lengthInput >= 3) {
        if (numberttt >= 3) {
          $this.show();
        } else {
          $this.hide();
        }
      } else if (lengthInput === 2) {
       if (numberttt === 2) {
          $this.show();
        } else {
          $this.hide();
        }
      } else if (lengthInput === 1) {
        if (numberttt === 1) {
          $this.show();
        } else {
          $this.hide();
        }
      } else {
        
      }
    });
  });
});
$(".clear_filter").click(function(){
  $(".quiz_input_items input").prop("checked", false);
  $('li.grid__item.quiz_li_items').attr('data_length','0');
  $('li.grid__item.quiz_li_items').show();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".mySwiper_home_projects ", {
      slidesPerView: 1.3,
      spaceBetween: 10,
      loop:true,
      centeredSlides: true,
      breakpoints: {
        480: {
          slidesPerView: 1.9,
          spaceBetween: 15,
          centeredSlides: true
        },
        640: {
          slidesPerView: 2.3,
          spaceBetween: 25,
          centeredSlides: true
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 25,
          centeredSlides: false,
        }
      }
    });

  } catch(e) { console.error(e); }
})();
})();
